module.exports = __webpack_public_path__ + "static/img/examenis_logo.3a4aa54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/examenis_logo.svg
// module id = sn4O
// module chunks = 2